module.exports = __webpack_public_path__ + "static/media/27_A.ac805a76.png";